import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Box, IconButton, Tooltip, Link, Text } from '@chakra-ui/react';
import { FaWhatsapp, FaArrowUp } from 'react-icons/fa';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import Home from './Pages/Home';
import About from './Pages/About';
import AgroBusiness from './Pages/AgroBusiness';
import Industries from './Pages/Industries';
import Contact from './Pages/Contact';
import { MotionBox } from './Components/motion';

function ScrollToTop() {
  const { pathname, hash } = useLocation();

  React.useEffect(() => {
    if (hash) {
      const target = document.querySelector(hash);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}

function BackToTop() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <MotionBox
      position="fixed"
      bottom={{ base: '92px', md: '32px' }}
      right={{ base: '20px', md: '32px' }}
      zIndex={9998}
      initial={false}
      animate={{
        opacity: visible ? 1 : 0,
        scale: visible ? 1 : 0.7,
        pointerEvents: visible ? 'auto' : 'none',
      }}
      transition={{ duration: 0.3 }}
    >
      <IconButton
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Retour en haut de page"
        icon={<FaArrowUp />}
        bg="white"
        color="brand.700"
        borderRadius="full"
        w="46px"
        h="46px"
        boxShadow="card"
        border="1px solid"
        borderColor="gray.100"
        _hover={{ bg: 'brand.500', color: 'white', transform: 'translateY(-3px)' }}
        transition="all 0.25s"
      />
    </MotionBox>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Box minH="100vh" display="flex" flexDirection="column" position="relative">
        <Link
          href="#main-content"
          position="absolute"
          left="-9999px"
          zIndex={99999}
          _focus={{
            left: 4,
            top: 4,
            bg: 'brand.500',
            color: 'white',
            px: 4,
            py: 2,
            borderRadius: 'md',
            boxShadow: 'lg',
          }}
        >
          <Text fontSize="sm" fontWeight="600">
            Aller au contenu principal
          </Text>
        </Link>

        <Navbar />

        <Box as="main" id="main-content" flex="1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/agro-business" element={<AgroBusiness />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Box>

        <Footer />

        {/* ─── WHATSAPP FLOATING BUTTON ─── */}
        <Tooltip
          label="Discutez avec nous sur WhatsApp"
          placement="left"
          hasArrow
          bg="brand.700"
          color="white"
          fontSize="sm"
          px={3}
          py={2}
          borderRadius="md"
        >
          <Box position="fixed" bottom={{ base: '28px', md: '32px' }} right={{ base: '20px', md: '32px' }} zIndex={9999}>
            <Box
              position="absolute"
              inset={0}
              borderRadius="full"
              bg="brand.500"
              className="animate-pulse-ring"
              pointerEvents="none"
            />
            <IconButton
              as="a"
              href="https://wa.me/243810330830?text=Bonjour%20TRIMER%20SARL%20!"
              target="_blank"
              rel="noopener noreferrer"
              icon={<FaWhatsapp size="26px" />}
              bg="brand.500"
              color="white"
              borderRadius="full"
              w="56px"
              h="56px"
              boxShadow="0 10px 28px -8px rgba(20,138,85,0.65)"
              _hover={{
                bg: 'brand.600',
                transform: 'scale(1.08)',
                boxShadow: '0 14px 34px -8px rgba(20,138,85,0.8)',
              }}
              transition="all 0.3s ease"
              aria-label="Chat on WhatsApp"
            />
          </Box>
        </Tooltip>

        <BackToTop />
      </Box>
    </Router>
  );
}

export default App;
